import React, {useEffect, useState} from 'react';
import HeroSlider from "./heroSlider";
import {useDispatch, useSelector} from "react-redux";
import {fetchPcategories} from "../../../reduxLib/pcategoriesLib";
import CategoryCard from "../Categories/categoryCard";
import {fetchProductsSummaryPopular} from "../../../reduxLib/productLib";
import ProductElementPopular from "../Products/ProductElements/productElementPopular";

function Home() {

    const[someCategories,setCategories]=useState([]);
    const categories= useSelector((state)=> state.categoryreducer.pcategoriesList);
    const state=useSelector((state)=> state.categoryreducer.status);
    const dispatchSR = useDispatch();
    const [productSummaryPagepop,setProductsSummaryPage]=useState([]);
    const summarypr= useSelector((state)=> state.productreducer.ProductsSummaryPopularL);
    const pstate=useSelector((state)=> state.productreducer.status);

    const dispatch = useDispatch();
    useEffect(() => {
        if(!categories||categories.length===0){
            dispatch(fetchPcategories()).then((action)=>{

                if (action.payload){
                    setCategories(action.payload);
                    console.log("playload ", action.payload);
                }
                else{

                }
            });
        }
        else {
            setCategories(categories);
            console.log("not disp ", categories);
        }


    },[dispatch,state,categories]);

    useEffect(()=>{
        if (!summarypr||summarypr.length===0){
            dispatchSR(fetchProductsSummaryPopular()).then((action)=>{
                if (action.payload){
                    setProductsSummaryPage(action.payload);
                    console.log("playload pr ", action.payload);
                }
            });
        }
        else {
            setProductsSummaryPage(summarypr);
        }
    },[dispatchSR,pstate,summarypr])
    return (
        <div>
            <main className="font-print">
              <HeroSlider />

                <section id="categories" className="py-20 bg-cream">
                    <div className="max-w-7xl mx-auto px-6">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl font-serif font-bold text-gray-800 mb-4">Browse Categories</h2>
                            <p className="text-lg text-gray-600 max-w-2xl mx-auto">From storage solutions to decorative
                                pieces, find the perfect basket for every need.</p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                           {

                                someCategories
                                    ?.slice()                 // copy array (important)
                                    .sort(() => 0.5 - Math.random())
                                    .slice(0, 4)
                                    .map(category => (
                                        <CategoryCard key={category.categoryID}  {
                                        ...{
                                            id: category.categoryID,
                                            name: category.name,
                                            description :category.description,
                                            image: category.image,
                                        }
                                    } />
                                ))

                            }
                        </div>
                    </div>
                </section>

                <section id="featured-products" className="py-20">
                    <div className="max-w-7xl mx-auto px-6">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl font-serif font-bold text-gray-800 mb-4">Featured Products</h2>
                            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Discover our most popular handcrafted
                                baskets, each one unique and made with care.</p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {
                                productSummaryPagepop?.map((product,index) => (
                                    <ProductElementPopular
                                        key={product.productID}
                                        {...{
                                            productID: product.productID,
                                            name: product.name,
                                            description: product.description,
                                            price: product.price,
                                            rating: product.rating,
                                            categoryRelId: product.categoryRelId,
                                            image: product.imageURL,
                                        }}
                                    />

                                ))
                            }
                        </div>
                    </div>
                </section>

            </main>

        </div>
    );
}

export default Home;